import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card, Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table'
import { clearTableData, fetchCreditManagementInputData } from './dispatch';

const PaymentAdjustmentDetails = (props) => {
    const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [meterId, setMeterId] = useState('');
    const [creditManagementFormData, setCreditManagementFormData] = useState({});
    const [errorsMasterValue, setErrorsMasterValue] = useState({});
    const { creditManagementInputData } = useSelector(state => state.creditManagementReducer); // customer number, consumer name, meter number, meter id
    const { creditManagementDropDownData } = useSelector(state => state.creditManagementReducer); // payment mode, payment source, payment type
    const { creditManagementTableData, isCreditManagementDataLoading } = useSelector(state => state.creditManagementReducer); // table data

    useEffect(() => {
        if (data) {
            //to get payment source, payment mode and payment type
            dispatch(fetchCreditManagementInputData({
                "userName": data?.pDATASET[0]?.USERNAME,
                "apiID": 3,
                "param1": 0,
                "param2": 0,
                "param3": 0,
                "param4": "",
                "param5": "",
                "param6": ""
            }, data.token));
        }
    }, []);

    const handleChange = (event, param) => {
        creditManagementFormData.CustomerNumber = '';
        let name = event?.target?.name;
        let value = event?.target?.value;
        setMeterId('');
        if (name == 'ConsumerNumber' && value.length >= 1 && data) {
            if (data) {
                //to get custome name, customer ID, Meter ID, Meter No
                dispatch(fetchCreditManagementInputData({
                    "userName": data?.pDATASET[0]?.USERNAME,
                    "apiID": 1,
                    "param1": parseInt(value), //customer number
                    "param2": 0,
                    "param3": 0,
                    "param4": data?.pDATASET[0]?.CIRCLE_CODE,
                    "param5": "",
                    "param6": ""
                }, data.token));
            }
        }
        if (param == 'FromDate' ||
            param == 'ToDate') {
            name = param;
            value = moment(event).format("YYYY-MM-DD").toString();
            setMeterId(meterId);
        }
        if(param == 'PaymentMode' || param == 'PaymentSource' || param == 'PaymentType') {
            setMeterId(meterId); 
        }
        if (param == 'MeterNumber') {
            if (!value) {
                setMeterId('');
            }
            for (let i = 0; i < creditManagementInputData.length; i++) {
                if (creditManagementInputData[i].METER_NO == value) {
                    setMeterId(creditManagementInputData[i].METER_ID)
                }
            }
        }
        setCreditManagementFormData(values => ({ ...values, [name]: value }))
    }

    const validateForm = () => {
        const newErrors = {};
        if (!creditManagementFormData?.ConsumerNumber) newErrors.ConsumerNumber = 'Consumer Number is required';
        if (!creditManagementFormData?.FromDate) newErrors.FromDate = 'From Date is required';
        return newErrors;
    };

    const handleSubmit = () => {
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrorsMasterValue(formErrors);
        } else {
            setErrorsMasterValue({});
            //to get table data
            dispatch(fetchCreditManagementInputData({
                "userName": data?.pDATASET[0]?.USERNAME,
                "apiID": 4,
                "param1": parseInt(creditManagementFormData?.ConsumerNumber?.length >= 1 && creditManagementInputData?.length > 0 && meterId != '' ? meterId : 0), //meter id
                "param2": parseInt(creditManagementFormData?.PaymentMode ? creditManagementFormData?.PaymentMode : 0), //payment mode
                "param3": parseInt(creditManagementFormData?.PaymentType ? creditManagementFormData?.PaymentType : 0), // payment type
                "param4": parseInt(creditManagementFormData?.PaymentSource ? creditManagementFormData?.PaymentSource : 0), // payment source
                "param5": moment(creditManagementFormData.FromDate).format('DD-MM-YY'), //from date
                "param6": moment(creditManagementFormData.ToDate).format('DD-MM-YY'), // to date
            }, data.token));
        }
    };

    const handleCancel = () => {
        setErrorsMasterValue({});
        setMeterId('');
        let formCancelObj = { ...creditManagementFormData };
        formCancelObj.ConsumerNumber = '';
        formCancelObj.MeterNumber = '';
        formCancelObj.PaymentMode = '';
        formCancelObj.PaymentType = '';
        formCancelObj.PaymentSource = '';
        formCancelObj.FromDate = moment(new Date()).format("YYYY-MM-DD");
        formCancelObj.FromDate = moment(new Date()).format("YYYY-MM-DD");
        dispatch(clearTableData(1));
        dispatch(clearTableData(4));
        setCreditManagementFormData(formCancelObj);
    }

    return (
        <div className='mainContainer'>
            <Card className="titleCard">
                <Card.Body className="d-flex align-items-center">
                    <Card.Title className="titleCardTitle">
                        Payment & Adjustment Details
                    </Card.Title>
                </Card.Body>
            </Card>
            {
                <Card className='bodyCard'>
                    <Card.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <>
                            <Form>
                                {
                                    (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
                                        <div className='bodyCardHeader'>
                                            <div style={{ marginLeft: '35px', display: 'flex', flexDirection: 'column' }}>
                                                <Form.Label className='robotoLight13 m-0'>State</Form.Label>
                                                <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.STATE_NAME}</Form.Label>
                                            </div>
                                            <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                                                <Form.Label className='robotoLight13 m-0'>Distict</Form.Label>
                                                <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.CIRCLE_NAME}</Form.Label>
                                            </div>
                                        </div> : null
                                }

                                <Row className='formRow mx-0'>
                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="consumerNumber" >
                                            <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                            <Form.Label className='robotoLight13'>Consumer Number</Form.Label>
                                            <Form.Control placeholder="00000000" className='robotoRegular15'
                                                value={creditManagementFormData?.ConsumerNumber}
                                                name="ConsumerNumber"
                                                onChange={handleChange}
                                                isInvalid={!!errorsMasterValue.ConsumerNumber} />
                                            <div className='robotoRegularRed13'>
                                                {errorsMasterValue.ConsumerNumber}
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="consumerId" >
                                            <Form.Label className='robotoLight13'>Consumer ID</Form.Label>
                                            <Form.Control className='robotoRegular15' style={{ marginTop: '5px' }}
                                                value={creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_ID : ''}
                                                name="ConsumerID"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="ConsumerName" >
                                            <Form.Label className='robotoLight13'>Consumer Name</Form.Label>
                                            <Form.Control className='robotoRegular15' style={{ marginTop: '5px' }}
                                                value={creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_NAME : ''}
                                                name="ConsumerName"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='formRow mx-0'>
                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="MeterNumber">
                                            <Form.Label className='robotoLight13'>Meter Number</Form.Label>
                                            <Form.Select defaultValue="Choose..."
                                                name="MeterNumber"
                                                value={creditManagementFormData?.MeterNumber}
                                                onChange={(e) => { handleChange(e, "MeterNumber") }}
                                                className='robotoRegular15'>
                                                <option value="">Please select</option>
                                                {
                                                    creditManagementInputData?.map((item) => {
                                                        return <option value={item.CATEGORY_ID}>{item.METER_NO}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="meterID" >
                                            <Form.Label className='robotoLight13'>Meter ID</Form.Label>
                                            <Form.Control className='robotoRegular15'
                                                value={meterId}
                                                name="meterID"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='formRow mx-0'>
                                    <Form.Group as={Col} sm={3} controlId="FromDate" style={{ marginLeft: '12px' }}>
                                        <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                        <Form.Label className='robotoLight13'>From Date</Form.Label>
                                        <Modal.Body isInvalid={!!errorsMasterValue.FromDate}>
                                            <DatePicker
                                                className='robotoRegular15'
                                                dateFormat="yyyy/MM/dd"
                                                selected={moment(creditManagementFormData?.FromDate).format("YYYY-MM-DD")}
                                                onChange={(date) => handleChange(date, 'FromDate')}
                                                icon={
                                                    <img src={require('../../assets/calender.png')}
                                                        style={{ right: 5, width: 20, height: 20 }}
                                                        onClick={() => setOpen(!open)} />
                                                }
                                                showIcon />
                                        </Modal.Body>
                                        <div className='robotoRegularRed13'>
                                            {errorsMasterValue.FromDate}
                                        </div>
                                    </Form.Group>
                                    <Form.Group as={Col} sm={3} controlId="ToDate" >
                                        <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                        <Form.Label className='robotoLight13'>To Date</Form.Label>
                                        <Modal.Body>
                                            <DatePicker
                                                className='robotoRegular15'
                                                dateFormat="yyyy/MM/dd"
                                                maxDate={moment().toDate()}
                                                selected={moment(creditManagementFormData?.ToDate).format("YYYY-MM-DD")}
                                                onChange={(date) => handleChange(date, 'ToDate')}
                                                icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() => setOpen(!open)} />}
                                                showIcon
                                                isInvalid={!!errorsMasterValue.ToDate} />
                                        </Modal.Body>
                                        <div className='robotoRegularRed13'>
                                            {errorsMasterValue.ToDate}
                                        </div>
                                    </Form.Group>
                                </Row>

                                {
                                    creditManagementDropDownData ?
                                        <Row className='formRow mx-0'>
                                            <Col md={3}>
                                                <Form.Group as={Col} controlId="PaymentMode" >
                                                    <Form.Label className='robotoLight13'>Payment Mode</Form.Label>
                                                    <Form.Select defaultValue="Choose..."
                                                        name="PaymentMode"
                                                        value={creditManagementFormData?.PaymentMode}
                                                        onChange={(e) => { handleChange(e, 'PaymentMode') }}
                                                        className='robotoRegular15'>
                                                        <option value="">Please select</option>
                                                        {
                                                            creditManagementDropDownData?.map((item) => {
                                                                if (item.TYPE == 'PAYMENTMODE')
                                                                    return <option value={item.ID}>{item.NAME}</option>
                                                            })
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group as={Col} controlId="PaymentSource" >
                                                    <Form.Label className='robotoLight13'>Payment Source</Form.Label>
                                                    <Form.Select defaultValue="Choose..."
                                                        name="PaymentSource"
                                                        value={creditManagementFormData?.PaymentSource}
                                                        onChange={(e) => { handleChange(e, 'PaymentSource') }}
                                                        className='robotoRegular15'>
                                                        <option value="">Please select</option>
                                                        {
                                                            creditManagementDropDownData?.map((item) => {
                                                                if (item.TYPE == 'PAYMENTSOURCE')
                                                                    return <option value={item.ID}>{item.NAME}</option>
                                                            })
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group as={Col} controlId="PaymentType">
                                                    <Form.Label className='robotoLight13'>Payment Type</Form.Label>
                                                    <Form.Select defaultValue="Choose..."
                                                        name="PaymentType"
                                                        value={creditManagementFormData?.PaymentType}
                                                        onChange={(e) => { handleChange(e, 'PaymentType') }}
                                                        isInvalid={!!errorsMasterValue.PaymentType}
                                                        className='robotoRegular15'>
                                                        <option value="">Please select</option>
                                                        {
                                                            creditManagementDropDownData?.map((item) => {
                                                                if (item.TYPE == 'PAYMENTTYPE')
                                                                    return <option value={item.ID}>{item.NAME}</option>
                                                            })
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row> : null
                                }

                                <div className='formBtn'>
                                    <Button variant="primary"
                                        onClick={() => { handleCancel() }}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" style={{ marginLeft: '15px' }}
                                        onClick={() => { handleSubmit() }}>
                                        Submit
                                    </Button>
                                </div>
                                <div className='tableData' style={{marginBottom: '20px'}}>
                                    {
                                        isCreditManagementDataLoading ?
                                            <Form.Label className='robotoLight13'>Loading .....</Form.Label> :
                                            creditManagementTableData && creditManagementTableData.length > 0 ?
                                                <Table className="table table-striped table-light">
                                                    <thead>
                                                        <tr>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Meter Number</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Meter Id</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Date</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Mode</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Type</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Source</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Amount</th>
                                                            <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {creditManagementTableData?.map((listValue, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.METER_NO}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.METER_ID}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{moment(listValue?.PAYMENT_DATE).format('YYYY-MM-DD HH:mm')}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_MODE}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_TYPE}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMNET_SOURCE}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_AMOUNT}</td>
                                                                    <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_REMARKS}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </Table> : creditManagementTableData?.length == 0 ? <div className='robotoRegular15' style={{ textAlign: 'center' }}>No Records Found!!</div> : null
                                    }
                                </div>
                                {
                                    creditManagementTableData && creditManagementTableData.length > 0 ?
                                        <div className='formBtn'>
                                            <Button variant="primary">
                                                Download
                                            </Button>
                                        </div> : null
                                }
                            </Form>
                        </>
                    </Card.Body>
                </Card>
            }
        </div>
    );
}

export default PaymentAdjustmentDetails;
